// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"body_cardBody__2CmTp","cardTitle":"body_cardTitle__2dWtL"};